import React, { useState } from "react";
import "../../css/style.css";
import logo from "../../images/logo.png";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [menuActive, setMenuActive] = useState(false);
  const location = useLocation();
  const toggleMenu = () => setMenuActive(!menuActive);

  return (
    <nav
      className="navbar"
      style={{
        background:
          "linear-gradient(135deg, #0b1020 0%, #0e1326 50%, #0f1731 100%)",
        backdropFilter: "blur(20px)",
        paddingTop: "4rem",
        paddingBottom : "4rem",
      }}
    >
      <div className="logo">
        <img src={logo} alt="Connect767 Logo" />
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        &#9776;
      </div>

      <ul className={`nav-links ${menuActive ? "active" : ""}`}>
        <li>
          <a href="/" className={location.pathname === "/" ? "active" : ""}>
            HOME
          </a>
        </li>
        <li>
          <a
            href="https://shop.connect767.com/"       
            target="_blank"
            rel="noreferrer"
          >
            SHOP
          </a>
        </li>
        <li>
           <Link to="/colar" >CUSTOM UNIFORMS</Link>
        </li>
      
      </ul>

      <div className="navbar-right">
        <div className="auth-links">
          <a href="/login" className="auth-button">
            Login
          </a>
          <a href="/signup" className="auth-button">
            Sign Up
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
